/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleCreateRequestMetadata } from './moduleCreateRequestMetadata';
import type { IdReference } from './idReference';
import type { ModuleCreateRequestState } from './moduleCreateRequestState';
import type { ModuleCreateRequestMandates } from './moduleCreateRequestMandates';

/**
 * How to create/filter for modules
 */
export interface ModuleCreateRequest {
  title?: string;
  metadata?: ModuleCreateRequestMetadata;
  author: IdReference;
  state?: ModuleCreateRequestState;
  mandates?: ModuleCreateRequestMandates;
}
